import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/no-data/table-empty.png';
const _hoisted_1 = {
  class: "category-page common-page"
};
const _hoisted_2 = {
  class: "page-title"
};
const _hoisted_3 = {
  class: "search"
};
const _hoisted_4 = {
  class: "search-form"
};
const _hoisted_5 = {
  class: "artice-list"
};
import { reactive, ref, onMounted } from "vue";
import { addLoading } from "@/utils/element-method";
import { ElMessage, ElMessageBox } from "element-plus";
import diseaseDialog from "./components/disease-dialog.vue";
import recommendDialog from "./components/recommend-dialog.vue";
// import noEat from "./components/no-eat.vue";
// import smallEat from "./components/small-eat.vue";
import eatSet from "./components/eat-set.vue";
import { getDiseaseListPage, deleteDisease, deleteDiseaseBatch, importItemOrIngred } from "@/service/modules/scan";
import protoPagination from "@/components/proto-pagination.vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'disease',
  setup(__props) {
    const diseaseList = ref([]);
    const selectedDiseases = ref([]);
    const diseaseDialogVisible = ref(false);
    const diseaseDialogType = ref("add");
    const diseaseData = ref({});
    const recommendDialogVisible = ref(false);
    const currentDiseaseData = ref({});
    const total = ref(0);
    const page = reactive({
      current: 1,
      size: 10
    });
    const form = reactive({
      name: ""
    });
    // 表格引用
    const tableRef = ref(null);
    onMounted(() => {
      getDiseaseList();
    });
    function handleClearCaseList() {
      form.name = "";
      page.current = 1;
      getDiseaseList();
    }
    function restCaseList() {
      getDiseaseList();
    }
    // 处理表格选择变化
    function handleSelectionChange(selection) {
      selectedDiseases.value = selection;
    }
    // 批量删除
    function handleDeleteBatch() {
      if (selectedDiseases.value.length === 0) {
        ElMessage.warning("请选择要删除的疾病");
        return;
      }
      ElMessageBox.confirm(`确定删除选中的 ${selectedDiseases.value.length} 个疾病吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        try {
          const ids = selectedDiseases.value.map(disease => disease.id);
          await deleteDiseaseBatch(ids);
          ElMessage.success("批量删除成功");
          selectedDiseases.value = [];
          getDiseaseList();
        } catch (error) {
          console.error("批量删除失败", error);
          ElMessage.error("批量删除失败");
        }
      }).catch(() => {
        // 用户点击取消按钮时，不做任何操作
      });
    }
    const forbiddenDialogVisible = ref(false);
    const forbiddenDialogType = ref(1);
    // const smallForbiddenDialogVisible = ref(false);
    const currentForbiddenData = ref({});
    // getDiseaseList();
    function handleImport() {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = ".xlsx,.xls,.csv";
      input.onchange = async event => {
        const file = event.target.files?.[0];
        if (!file) return;
        const loading = addLoading();
        try {
          const formData = new FormData();
          formData.append("file", file);
          await importItemOrIngred(formData);
          ElMessage.success("导入成功");
          getDiseaseList(); // 刷新列表
        } catch (error) {
          ElMessage.error("导入失败：" + error.message);
        } finally {
          loading.close(); // 无论成功还是失败，都关闭loading
        }
      };
      input.click();
    }
    async function getDiseaseList() {
      try {
        console.log("page", page, 123);
        let res = await getDiseaseListPage({
          ...page,
          ...form
        });
        diseaseList.value = res.data.records;
        total.value = Number(res.data.total);
        console.log("获取到的数据总数:", total.value);
      } catch (error) {
        console.log(error);
      }
    }
    function handlIngredTableCurrentChange(val) {
      page.current = val;
      getDiseaseList();
    }
    function handleDelete(id) {
      ElMessageBox.confirm("确定删除该疾病吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        await deleteDisease(id);
        ElMessage.success("删除成功");
        getDiseaseList();
      }).catch(() => {
        // 用户点击取消按钮时，不做任何操作
        // 或者可以添加一些提示信息
      });
    }
    function handleUpdate(id) {
      // 找到要编辑的疾病项
      const item = diseaseList.value.find(disease => disease.id === id);
      if (item) {
        diseaseDialogType.value = "edit";
        diseaseData.value = item;
        diseaseDialogVisible.value = true;
      }
    }
    function handleDiseaseTableCurrentChange(val) {
      page.current = val;
      getDiseaseList();
    }
    function handleUserTableSizeChange(val) {
      page.size = val;
      getDiseaseList();
    }
    function handleOpenItemDialog() {
      diseaseDialogType.value = "add";
      diseaseData.value = {};
      diseaseDialogVisible.value = true;
    }
    function handleCloseItemDialog() {
      diseaseDialogType.value = "add";
      diseaseData.value = {};
      diseaseDialogVisible.value = false;
      getDiseaseList(); // 关闭对话框后刷新列表
    }
    const recommendDialogType = ref(1);
    function handleRecommend(row, type) {
      currentDiseaseData.value = row;
      recommendDialogVisible.value = true;
      recommendDialogType.value = type;
    }
    function handleCloseRecommendDialog() {
      recommendDialogVisible.value = false;
      currentDiseaseData.value = {};
      getDiseaseList();
    }
    function handleForbidden(row, eatType) {
      currentForbiddenData.value = row;
      forbiddenDialogVisible.value = true;
      forbiddenDialogType.value = eatType;
    }
    // function handleSmallForbidden(row: any) {
    //   currentForbiddenData.value = row;
    //   smallForbiddenDialogVisible.value = true;
    // }
    function handleCloseForbiddenDialog() {
      forbiddenDialogVisible.value = false;
      currentForbiddenData.value = {};
      getDiseaseList();
    }
    // function handleCloseSmallForbiddenDialog() {
    //   smallForbiddenDialogVisible.value = false;
    //   currentForbiddenData.value = {};
    // }
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_table = _resolveComponent("el-table");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[4] || (_cache[4] = _createTextVNode(" 疾病管理 ")), _createVNode(_component_el_button, {
        type: "primary",
        style: {
          "margin-left": "5px"
        },
        onClick: handleOpenItemDialog
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("新增")])),
        _: 1
      }), _createVNode(_component_el_button, {
        onClick: handleDeleteBatch,
        type: "danger",
        style: {
          "margin-left": "5px"
        },
        disabled: selectedDiseases.value.length === 0
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("批量删除")])),
        _: 1
      }, 8, ["disabled"])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_form, {
        inline: true,
        model: form,
        class: "demo-form-inline"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "名称",
          prop: "name"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.name = $event),
            style: {
              "width": "180px"
            },
            placeholder: "请输入名称",
            clearable: ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = $event => handleClearCaseList())
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("重置")])),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            onClick: restCaseList
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("搜索")])),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "success",
            onClick: handleImport
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("导入")])),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_table, {
        ref_key: "tableRef",
        ref: tableRef,
        data: diseaseList.value,
        "header-cell-style": {
          background: '#F7F9FB !important',
          color: '#111111',
          height: '42px',
          fontSize: '14px'
        },
        style: {
          "width": "100%"
        },
        onSelectionChange: handleSelectionChange
      }, {
        empty: _withCtx(() => _cache[20] || (_cache[20] = [_createElementVNode("div", {
          class: "table-empty"
        }, [_createElementVNode("img", {
          class: "no-data",
          src: _imports_0,
          alt: ""
        }), _createElementVNode("div", {
          class: "empty-text"
        }, "暂无数据")], -1)])),
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          type: "selection",
          width: "55"
        }), _createVNode(_component_el_table_column, {
          label: "序号",
          "min-width": "70"
        }, {
          default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.$index + 1 + (page.current - 1) * page.size), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "name",
          label: "疾病名称",
          "show-overflow-tooltip": "",
          "min-width": "180"
        }), _createVNode(_component_el_table_column, {
          prop: "recommendQty",
          label: "推荐商品数",
          "min-width": "120"
        }), _createVNode(_component_el_table_column, {
          prop: "inedibleQty",
          label: "不可食用物品数",
          "min-width": "120"
        }), _createVNode(_component_el_table_column, {
          prop: "ingredientsQty",
          label: "不可食用成分数",
          "min-width": "120"
        }), _createVNode(_component_el_table_column, {
          label: "操作",
          "min-width": "350",
          fixed: "right"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_dropdown, {
            style: {
              "vertical-align": "middle"
            }
          }, {
            dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [_createVNode(_component_el_dropdown_item, null, {
                default: _withCtx(() => [_createVNode(_component_el_link, {
                  class: "m-r-10",
                  type: "primary",
                  onClick: $event => handleForbidden(scope.row, 1)
                }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("可食用配置")])),
                  _: 2
                }, 1032, ["onClick"])]),
                _: 2
              }, 1024), _createVNode(_component_el_dropdown_item, null, {
                default: _withCtx(() => [_createVNode(_component_el_link, {
                  class: "m-r-10",
                  type: "primary",
                  onClick: $event => handleForbidden(scope.row, 2)
                }, {
                  default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("不可食用配置")])),
                  _: 2
                }, 1032, ["onClick"])]),
                _: 2
              }, 1024), _createVNode(_component_el_dropdown_item, null, {
                default: _withCtx(() => [_createVNode(_component_el_link, {
                  class: "m-r-10",
                  type: "primary",
                  onClick: $event => handleForbidden(scope.row, 3)
                }, {
                  default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode("限量食用配置")])),
                  _: 2
                }, 1032, ["onClick"])]),
                _: 2
              }, 1024)]),
              _: 2
            }, 1024)]),
            default: _withCtx(() => [_cache[11] || (_cache[11] = _createElementVNode("span", {
              class: "el-dropdown-link m-r-10",
              style: {
                "color": "var(--el-color-primary)",
                "cursor": "pointer"
              }
            }, " 食用配置 ", -1))]),
            _: 2
          }, 1024), _createVNode(_component_el_dropdown, {
            style: {
              "vertical-align": "middle"
            }
          }, {
            dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [_createVNode(_component_el_dropdown_item, null, {
                default: _withCtx(() => [_createVNode(_component_el_link, {
                  class: "m-r-10",
                  type: "primary",
                  onClick: $event => handleRecommend(scope.row, 1)
                }, {
                  default: _withCtx(() => _cache[12] || (_cache[12] = [_createTextVNode("可食用商品")])),
                  _: 2
                }, 1032, ["onClick"])]),
                _: 2
              }, 1024), _createVNode(_component_el_dropdown_item, null, {
                default: _withCtx(() => [_createVNode(_component_el_link, {
                  class: "m-r-10",
                  type: "primary",
                  onClick: $event => handleRecommend(scope.row, 2)
                }, {
                  default: _withCtx(() => _cache[13] || (_cache[13] = [_createTextVNode("不可食用商品")])),
                  _: 2
                }, 1032, ["onClick"])]),
                _: 2
              }, 1024), _createVNode(_component_el_dropdown_item, null, {
                default: _withCtx(() => [_createVNode(_component_el_link, {
                  class: "m-r-10",
                  type: "primary",
                  onClick: $event => handleRecommend(scope.row, 3)
                }, {
                  default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode("限量食用商品")])),
                  _: 2
                }, 1032, ["onClick"])]),
                _: 2
              }, 1024), _createVNode(_component_el_dropdown_item, null, {
                default: _withCtx(() => [_createVNode(_component_el_link, {
                  class: "m-r-10",
                  type: "primary",
                  onClick: $event => handleRecommend(scope.row, 4)
                }, {
                  default: _withCtx(() => _cache[15] || (_cache[15] = [_createTextVNode("推荐商品")])),
                  _: 2
                }, 1032, ["onClick"])]),
                _: 2
              }, 1024), _createVNode(_component_el_dropdown_item, null, {
                default: _withCtx(() => [_createVNode(_component_el_link, {
                  class: "m-r-10",
                  type: "primary",
                  onClick: $event => handleRecommend(scope.row, 5)
                }, {
                  default: _withCtx(() => _cache[16] || (_cache[16] = [_createTextVNode("不可出现商品")])),
                  _: 2
                }, 1032, ["onClick"])]),
                _: 2
              }, 1024)]),
              _: 2
            }, 1024)]),
            default: _withCtx(() => [_cache[17] || (_cache[17] = _createElementVNode("span", {
              class: "el-dropdown-link m-r-10",
              style: {
                "color": "var(--el-color-primary)",
                "cursor": "pointer"
              }
            }, " 商品配置 ", -1))]),
            _: 2
          }, 1024), _createVNode(_component_el_link, {
            class: "m-r-10",
            type: "primary",
            onClick: $event => handleUpdate(scope.row.id)
          }, {
            default: _withCtx(() => _cache[18] || (_cache[18] = [_createTextVNode("编辑")])),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_link, {
            type: "danger",
            onClick: $event => handleDelete(scope.row.id)
          }, {
            default: _withCtx(() => _cache[19] || (_cache[19] = [_createTextVNode("删除")])),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"]), _createVNode(protoPagination, {
        page: page,
        total: total.value,
        onCurrentChange: handleDiseaseTableCurrentChange,
        onSizeChange: handleUserTableSizeChange
      }, null, 8, ["page", "total"])])]), _createVNode(diseaseDialog, {
        "dialog-visible": diseaseDialogVisible.value,
        "dialog-type": diseaseDialogType.value,
        "item-data": diseaseData.value,
        onCloseDialog: handleCloseItemDialog
      }, null, 8, ["dialog-visible", "dialog-type", "item-data"]), _createVNode(recommendDialog, {
        "dialog-visible": recommendDialogVisible.value,
        "item-data": currentDiseaseData.value,
        onCloseDialog: handleCloseRecommendDialog,
        "eat-type": recommendDialogType.value,
        type: 3
      }, null, 8, ["dialog-visible", "item-data", "eat-type"]), _createVNode(eatSet, {
        "dialog-visible": forbiddenDialogVisible.value,
        "disease-id": currentForbiddenData.value.id,
        onCloseDialog: handleCloseForbiddenDialog,
        "eat-type": forbiddenDialogType.value
      }, null, 8, ["dialog-visible", "disease-id", "eat-type"])], 64);
    };
  }
});